export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5414.7dbeb02c.jpg";